import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Authenticate} from '../models/user';
import {AuthResources} from './auth-resources';
import {environment} from '../../../environments/environment';
import {authErrorSelector} from './auth-error-selectors';

@Injectable()
export class TokenService {

    constructor(private http: HttpClient) {
    }

    get resourceUrl(): string {
        return environment.rest_backend + AuthResources.tokenResource;
    }

    public getToken({email, password}: Authenticate): Observable<string> {
        const requestBody = {
            username: email,
            password: password
        };
        return this.http.post(this.resourceUrl, requestBody, {
            withCredentials: false
        }).pipe(
            map(e => <string>e),
            catchError(authErrorSelector)
        );
    }
}
